// extracted by mini-css-extract-plugin
export default {"page":"PermissionsPage_page__7Wpc+","content":"PermissionsPage_content__P9tZ3","table":"PermissionsPage_table__oky-P","permissionCell":"PermissionsPage_permissionCell__wwIYd"};